var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftwarePackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M24.825 55.95A6.074 6.074 0 0 0 24 59.025v73.95a6.077 6.077 0 0 0 3.075 5.25l66 37.125c.89.508 1.9.768 2.925.75l.675-80.1-71.85-40.05Z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M168 105.975v-46.95a6.076 6.076 0 0 0-3.075-5.25l-66-37.125a5.85 5.85 0 0 0-5.85 0l-66 37.125A6.075 6.075 0 0 0 24 59.025v73.95a6.077 6.077 0 0 0 3.075 5.25l66 37.125a5.855 5.855 0 0 0 5.85 0L117 165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M132.75 98.375v-23L60 35.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M167.175 55.95 96.675 96l-71.85-40.05M96.675 96 96 176.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: "M166 139h7.5c1.989 0 3.897-.843 5.303-2.343 1.407-1.5 2.197-3.535 2.197-5.657s-.79-4.157-2.197-5.657c-1.406-1.5-3.314-2.343-5.303-2.343H166v24m-13-24v24m-28-24h16l-16 24h16"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwarePackage);
export default __webpack_public_path__ + "static/media/SoftwarePackage.3a89e8d5dc7b3863b110713216edd526.svg";
export { ForwardRef as ReactComponent };